import initials from 'initials'
import randomColor from 'randomcolor'

const fillColorText = (ctx: CanvasRenderingContext2D, name: string, x: number, y: number): void => {
  ctx.save()

  const middlePoint = ctx.measureText(name).width / 2

  const letterColors = randomColor({
    count: initials.length,
    luminosity: 'bright',
    seed: name,
  })

  for (let i = 0; i < name.length; i++) {
    ctx.fillStyle = letterColors[i]
    ctx.fillText(name[i], x - middlePoint, y)

    x += ctx.measureText(name[i]).width
  }

  ctx.restore()
}

const isValidImage = (source: string): boolean => {
  return typeof source !== 'undefined'
    && source !== null
    && source !== ''
    && source.indexOf('http') !== -1
}

const getUserInitials = (name: string): string => {
  if (name === null) {
    return ''
  }

  const firstName = name.split(' ')[0]
  const nameFormat = (firstName[0] || '').toUpperCase() + (firstName.substr(1) || '').toLowerCase()

  return initials(nameFormat)
}

export const userAvatar = (source: string, name: string, size: number = 256): string => {
  if (isValidImage(source)) {
    return source
  }

  const userInitials = getUserInitials(name)

  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  canvas.style.display = 'none'
  canvas.width = 512
  canvas.height = 512

  ctx.fillStyle = randomColor({ luminosity: 'dark', seed: name })
  ctx.fillRect(0, 0, 512, 512)
  ctx.font = '500 230px "Montserrat", Arial, Helvetica, sans serif'
  ctx.fillStyle = 'rgba(255,255,255, 0.95)'
  ctx.textAlign = 'center'
  ctx.textBaseline = 'middle'
  ctx.fillText(userInitials, size, size)

  const base64 = canvas.toDataURL('image/jpeg')
  canvas.remove()

  return base64
}

export const companyAvatar = (source: string, companyName: string, size: number = 256): string => {
  if (isValidImage(source)) {
    return source
  }

  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  const companyInitials = initials(companyName).toUpperCase().substr(0, 2)

  canvas.style.display = 'none'
  canvas.width = 512
  canvas.height = 512

  ctx.fillStyle = '#FFF'
  ctx.fillRect(0, 0, 512, 512)
  ctx.font = '500 260px "Montserrat", Arial, Helvetica, sans serif'
  ctx.textBaseline = 'middle'

  fillColorText(ctx, companyInitials, size, size)

  const base64 = canvas.toDataURL('image/jpeg')
  canvas.remove()

  return base64
}

export const fileAvatar = (initials: string, size:number = 256): string => {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  canvas.style.display = 'none'
  canvas.width = 512
  canvas.height = 512

  ctx.fillStyle = '#FFF'
  ctx.fillRect(0, 0, 512, 512)
  ctx.font = '500 145px "Montserrat", Arial, Helvetica, sans serif'
  ctx.textBaseline = 'middle'

  fillColorText(ctx, initials, size, size)

  const base64 = canvas.toDataURL('image/jpeg')
  canvas.remove()

  return base64
}

export default {
  userAvatar,
  companyAvatar,
  fileAvatar,
}